module.exports = __webpack_public_path__ + "img/kimandjax-87a9c4b1-3846-437b-d5b0-08d95d819f98.png";